import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";
import * as React from "react";

export interface SpinnerProps extends React.HTMLAttributes<SVGElement> {
  className?: string;
  "aria-label"?: string;
}

export function Spinner({ className, "aria-label": ariaLabel, ...props }: SpinnerProps) {
  return (
    <Loader2
      className={cn("h-4 w-4 animate-spin", className)}
      aria-label={ariaLabel}
      role={ariaLabel ? "status" : undefined}
      {...props}
    />
  );
}
